import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnsupported = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 56,
	viewBox: "0 0 44 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M22 23C15.4 23 10 28.4 10 35C10 41.6 15.4 47 22 47C28.6 47 34 41.6 34 35C34 28.4 28.6 23 22 23ZM22 27C23.5 27 24.9 27.4 26.1 28.1L15.1 39.1C14.4 37.9 14 36.5 14 35C14 30.6 17.6 27 22 27ZM22 43C20.5 43 19.1 42.6 17.9 41.9L28.8 31C29.5 32.2 29.9 33.6 29.9 35.1C30 39.4 26.4 43 22 43Z" }), /* @__PURE__ */ _jsx("path", { d: "M24 0H5C2.2 0 0 2.2 0 5V51C0 53.8 2.2 56 5 56H39C41.8 56 44 53.8 44 51V20C44 9 35 0 24 0ZM39 14.6C38.1 14.2 37 14 36 14H30V8C30 6.9 29.8 5.9 29.4 5C33.9 6.6 37.4 10.1 39 14.6ZM40 51C40 51.6 39.6 52 39 52H5C4.4 52 4 51.6 4 51V5C4 4.4 4.4 4 5 4H22C24.2 4 26 5.8 26 8V16C26 17.1 26.9 18 28 18H36C38.2 18 40 19.8 40 22V51Z" })]
});
export default SvgUnsupported;
